










































import { computed, defineComponent } from '@vue/composition-api';
import Logo from '@/assets/iot-logo.svg';
import useOidc from '@/composables/useOidc';
import { RouteMeta } from 'vue-router/types/router';
import useProfile from '@/composables/useProfile';
import { IOT_READ_ONLY } from '@/constants';

export default defineComponent({
  components: {
    Logo
  },
  setup(_, { root }) {
    const { roles, isReadOnly } = useProfile();

    var routes = computed(() =>
      root.$router
        .getRoutes()
        .filter(route => route.meta.includeInNavigationBar)
        .filter(route =>
          (route.meta as RouteMeta).roleRequirements?.some(
            (role: string) => roles.value?.includes(role) || role === IOT_READ_ONLY
          )
        )
    );

    const logOut = () => {
      useOidc().logOut();
    };

    return {
      routes,
      userName: computed(() => useOidc().user.value?.profile.name),
      isLoggedIn: computed(() => useOidc().user.value != null),
      logOut
    };
  }
});
